<template>
    <v-container>

        <v-row v-if="!$props.param.collectMode">
        <v-col>
            <v-menu v-model="startDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                    <v-text-field v-model="startDate" color="#c42111" label="Start Date" prepend-icon="event" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="startDate" color="#c42111" @input="startDateMenu = false" @change="onChange('start')" no-title scrollable />
            </v-menu>
        </v-col>

        <v-col>
            <v-menu v-model="endDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                    <v-text-field v-model="endDate" color="#c42111" label="End Date" prepend-icon="event" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="endDate" color="#c42111" @input="endDateMenu = false" @change="onChange('end')" no-title scrollable />
            </v-menu>
        </v-col>
        </v-row>

        <v-row v-if="$props.param.collectMode">
            <v-col>
                <v-select v-model="selectedDay" color="#c42111" :items="days" @change="onChange" />
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
export default {
    name: 'DateRange',
    props: ['param'],
    data: () => ({
        startDateMenu: false,
        endDateMenu: false,
        startDate: TELSA.moment().subtract(1, 'days').format("YYYY-MM-DD"),
        endDate: TELSA.moment().subtract(1, 'days').format("YYYY-MM-DD"),
        thresdays: null,
        days: [],
        selectedDay: null
    }),

    computed: {

    },

    methods: {
        allowedStartDates: function(d) {
            return (TELSA.moment(d) <= TELSA.moment(this.endDate));
        },

        allowedEndDates: function(d) {
            return (TELSA.moment(d) >= TELSA.moment(this.startDate));
        },

        onChange: function(type) {
            if(TELSA.moment(this.startDate).isAfter(TELSA.moment(this.endDate))) {
                if(type == 'start') {
                    this.endDate = TELSA.moment(this.startDate).format('YYYY-MM-DD');
                }
                else if(type == 'end') {
                    this.startDate = TELSA.moment(this.endDate).format('YYYY-MM-DD');
                }
            }
            
            if(!this.$props.param.collectMode) {
                this.param.selectedValue = `${this.startDate} ${TELSA.moment(this.endDate).add(1, 'days').format("YYYY-MM-DD")}`;
                this.param.humanText = `${this.startDate} to ${this.endDate}`;
            }
            else {
                this.param.selectedValue = `${this.days.indexOf(this.selectedDay)}`;
                this.param.humanText = `${this.selectedDay}`;
            }

            this.$emit('edit');
        },

        buildList: function() {
            if(!this.$props.param.collectMode) {
                return;
            }
            this.thresdays = (this.$store.state.batchConfig.thres_days && !isNaN(parseInt(this.$store.state.batchConfig.thres_days))) ? parseInt(this.$store.state.batchConfig.thres_days) : 7;
            for(let i = 1; i <= this.thresdays; i++) {
                this.days.push(`${i} ${(i == 1) ? 'day' : 'days'}`);
            }
            this.selectedDay = this.days[0];
        },

        setInputsInitialValue: function() {
            if(this.$props.param.encodedValue == undefined) {
                return;
            }
            if(this.$props.param.collectMode) {
                const index = parseInt(this.$props.param.encodedValue);
                this.selectedDay = this.days[index];
            }
            else {
                const parts = this.$props.param.encodedValue.split(' ');
                this.startDate = TELSA.moment(parts[0]).format("YYYY-MM-DD");
                this.endDate = TELSA.moment(parts[1]).subtract(1, 'days').format("YYYY-MM-DD");
            }
        }
    },

    mounted() {
        this.buildList();
        this.setInputsInitialValue();
        this.onChange();
    }
};
</script>

<style scoped>

    .date-range-picker {
        margin-right: 3em;
    }
    @media (max-width: 650px) {
        .date-range-picker {
            width: 300px;
            display: block;
            margin-bottom: 1em;
        }
    }
    

</style>

